class ResourceGatedModal extends HTMLElement {
  constructor() {
    super();
    this.showOnLoad = this.dataset.showOnLoad === 'true';
    this.isOpen = false;

    // Bind methods
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    if (this.showOnLoad) {
      this.open();
    }

    // Add event listeners
    const form = this.querySelector('.resource-gated-modal__form');
    console.log(form);
    form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    const form = this.querySelector('.resource-gated-modal__form');
    form.removeEventListener('submit', this.handleSubmit);
  }

  open() {
    if (!this.isOpen) {
      this.setAttribute('open', '');
      document.body.classList.add('no-scroll');
      this.isOpen = true;
    }
  }

  close() {
    if (this.isOpen) {
      this.removeAttribute('open');
      document.body.classList.remove('no-scroll');
      this.isOpen = false;
      console.log('Modal closed');
    } else {
      console.log('Modal was already closed');
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    const emailInput = this.querySelector('input[type="email"]');
    const phoneInput = this.querySelector('input[type="tel"]');
    const email = emailInput ? emailInput.value : null;
    const phone = phoneInput ? phoneInput.value : null;

    const createCustomer = this.dataset.create === 'true';

    const button = this.querySelector('.resource-gated-modal__form button');
    let originalButtonText = button.textContent;

    if (!email) {
      // Handle empty email
      button.textContent = 'Please enter an email';
      setTimeout(() => {
        button.textContent = originalButtonText;
      }, 2000);
      return;
    }

    try {
      await this.handleRequest(email, phone, createCustomer);
      console.log('Request successful, closing modal');
      this.close();
    } catch (error) {
      console.log(error.message);
      if (error.message == 'Profile not found') {
        this.querySelector('.resource-gated-modal__contact-support').classList.remove('resource-gated-hidden');
        this.querySelector('.resource-gated-modal__form-contact-support-button').classList.remove(
          'resource-gated-hidden'
        );
        button.textContent = error.message;
        setTimeout(() => {
          button.textContent = 'Try Again';
        }, 2000);
      } else if (error.message.includes('Invalid phone number format')) {
        console.log('Invalid phone number format');
        this.querySelector('.resource-gated-modal__info').classList.remove('hidden');
        this.querySelector('.resource-gated-modal__info').textContent = error.message;
        button.textContent = 'Try Again';
        setTimeout(() => {
          button.textContent = originalButtonText;
        }, 2000);
      } else {
        console.error('Error submitting form:', error);
        button.textContent = 'Try Again';
        setTimeout(() => {
          button.textContent = originalButtonText;
        }, 2000);
      }
    }
  }

  async handleRequest(email, phone, createCustomer) {
    const response = await fetch('https://dlg-shopify-hub-aexmgykrbq-uc.a.run.app/api/shopify/product/resources', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        phone: phone || null,
        resource_page: window.location.pathname,
        create_customer: createCustomer,
      }),
    });
    if (response.status === 200) {
      return;
    }
    if (response.status === 404) {
      throw new Error('Profile not found');
    }
    if (response.status === 400) {
      const data = await response.json();
      if (data.error == 'Invalid phone number format (Example of a valid format: +00000000000)') {
        throw new Error(data.error);
      } else {
        throw new Error(data.error);
      }
    } else {
      console.log(response);
      throw new Error('Something went wrong');
    }
  }
}

customElements.define('resource-gated-modal', ResourceGatedModal);

class PromoModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseIcon = this.handleCloseIcon.bind(this);
  }

  connectedCallback() {
    const closeButton = this.querySelector('#promo-modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', this.handleClose);
    }

    const closeIcon = this.querySelector('#promo-modal__close-icon');
    if (closeIcon) {
      closeIcon.addEventListener('click', this.handleCloseIcon);
    }
  }

  disconnectedCallback() {
    const closeButton = this.querySelector('#promo-modal__close-button');
    if (closeButton) {
      closeButton.removeEventListener('click', this.handleClose);
    }

    const closeIcon = this.querySelector('#promo-modal__close-icon');
    if (closeIcon) {
      closeIcon.removeEventListener('click', this.handleCloseIcon);
    }
  }

  open() {
    if (!this.isOpen) {
      this.setAttribute('open', '');
      document.body.classList.add('no-scroll');
      this.isOpen = true;
    } else {
      console.log('Modal was already open');
      document.body.classList.add('no-scroll');
    }
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('no-scroll');
    this.isOpen = false;
  }

  handleClose() {
    this.close();
  }
  handleCloseIcon() {
    this.close();
  }
}

customElements.define('promo-modal', PromoModal);

class ChallengeGatedModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = true; // Set initial state to false
    this.open = this.open.bind(this);
    this.submitButton = this.querySelector('#submit');
    // document.body.classList.add('no-scroll');

    this.handleSubmit = this.handleSubmit.bind(this);
  }
  connectedCallback() {
    // Ensure the modal is open on page load
    this.setAttribute('open', '');
    document.body.classList.add('no-scroll');
    const form = this.querySelector('#challengeForm');
    form.addEventListener('submit', this.handleSubmit);

    const challengeAccess = sessionStorage.getItem('challengeAccess');
    if (challengeAccess) {
      this.close();
    }
    const backButton = this.querySelector('#challengeForm--back-button');
    backButton.addEventListener('click', this.handleBackButton);
  }

  open() {
    if (!this.isOpen) {
      this.setAttribute('open', '');
      this.isOpen = true;
    } else {
      console.log('Modal was already open');
    }
    document.body.classList.add('no-scroll');
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('no-scroll');
    this.isOpen = false;
  }

  async handleSubmit(event) {
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    const supportButton = this.querySelector('.loading__spinner');
    supportButton.classList.remove('hidden');
    event.preventDefault();
    event.stopPropagation();
    const form = new FormData(event.target);
    const email = form.get('email');

    const checkEmail = await fetch(
      'https://dlg-shopify-hub-112932051133.us-central1.run.app/api/membership/challenge/check',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email }),
      }
    );
    const checkEmailData = await checkEmail.json();
    if (checkEmailData.message === 'Customer is a member') {
      this.submitButton.setAttribute('aria-disabled', false);
      this.submitButton.classList.remove('loading');
      supportButton.classList.add('hidden');
      sessionStorage.setItem('challengeAccess', 'true');
      this.close();
    } else {
      this.submitButton.setAttribute('aria-disabled', false);
      this.submitButton.classList.remove('loading');
      supportButton.classList.add('hidden');
      this.submitButton.classList.add('hidden');

      this.querySelector('#challengeForm--content').classList.add('hidden');
      this.querySelector('#challengeForm--error .no-access').classList.remove('hidden');
      this.querySelector('#challengeForm--error').classList.remove('hidden');
      this.querySelector('.support-buttons').classList.remove('hidden');
    }
  }
  handleBackButton() {
    document.querySelector('#challengeForm--error').classList.add('hidden');
    document.querySelector('.support-buttons').classList.add('hidden');
    document.querySelector('#challengeForm--content').classList.remove('hidden');
    document.querySelector('#submit').classList.remove('hidden');
  }
}

customElements.define('challenge-gated-modal', ChallengeGatedModal);
